import Axios from 'axios';
import i18n from 'i18next';

import { Language } from 'store/config/reducer.types';

import LANGUAGES_NAMES, { LanguagesNames } from 'utils/Language/languageNames';

export type Params = {
    languages: Partial<{
        [key in LanguagesNames]: Language;
    }>;
    currentLanguage: keyof typeof LANGUAGES_NAMES;
};

async function getTranslationsData({ languages, currentLanguage }: Params) {
    const languagesKeys = Object.keys(languages);

    await Promise.all(
        languagesKeys.map(async (ln) => {
            const language = languages[ln as LanguagesNames];

            if (!language?.url) {
                return;
            }

            const response = await Axios.get(language.url);

            if (response != null) {
                i18n.addResourceBundle(
                    ln,
                    'translation',
                    response.data,
                    true,
                    true,
                );
            }
        }),
    );

    // Trigger to update UI with new resources.
    await i18n.changeLanguage(currentLanguage);
}

export default getTranslationsData;
